let noticeSequence = 0;

/** Monotone IDs keep notification React keys unique for same-tick messages. */
export function nextNoticeId() {
  noticeSequence += 1;
  return noticeSequence;
}
